import Grid from '@mui/material/Grid'
import { Box } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import ExploreVehicleDetailsTile from 'src/components/BuyPolicy/insuranceScreens/bike/ExploreVehicleDetailsTile'
import ExplorePolicyTypes from 'src/components/BuyPolicy/insuranceScreens/bike/ExplorePolicyTypes'
import { VEHICLE_TYPE } from 'src/utils/constants/BuyPolicyBike'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  getAddOnsListBike,
  getBikeQuickQuotes,
} from 'src/services/buyPolicyBikeService'
import {
  showNotificationMessage,
  updateMotorDetails,
  updatePACoverArray,
} from 'src/actions'
import { createPaProviderObject } from 'src/utils/commonMethods/buyPolicy'
import LoadingModal from 'src/components/common/LoadingModal'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import BackArrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { useHistory } from 'react-router-dom'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { YES } from 'src/utils/constants/BuyPolicy'
import { ERROR_ON_ADDONS_LIST, NO_ADDONS } from 'src/utils/constants/Bike'

const BikeInsuranceDetails = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const isTwoWheeler =
    motorDetails.vehicleDetails.vehicleType === VEHICLE_TYPE?.TWO_WHEELER
  const paCoverDetails = useSelector((state) => state?.paCoverAmountReducer)
  const [motorQuote, setMotorQuote] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingQuote, setLoadingQuote] = useState(false)
  const [addOnsList, setAddOnsList] = useState([])

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const token = response?.res?.data?.access_token
      fetchBikeQuickQuote(token)
      fetchAddOnsList(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchBikeQuickQuote = async (token) => {
    setLoadingQuote(true)
    const formData = {
      userName: motorDetails?.personalDetails?.name,
      mobile: motorDetails?.personalDetails?.mobileNumber,
      email: motorDetails?.personalDetails?.email,
      makeId: motorDetails.vehicleDetails?.brand?.genericName,
      modelId: motorDetails?.vehicleDetails?.model?.id,
      variantId: motorDetails?.vehicleDetails?.variant?.id || '',
      fuelTypeId: motorDetails?.vehicleDetails?.fuelType?.id,
      registrationDate: motorDetails?.vehicleDetails?.regDate,
      vehicleNumber: motorDetails?.vehicleDetails?.vehicleNumber,
      previousInsuranceProvider:
        motorDetails?.previousPolicyDetails?.previousPolicyProvider
          ?.insuranceCompanyFirstName,
      previousPolicyNumber:
        motorDetails?.previousPolicyDetails?.previousPolicyNumber,
      claimsOnPreviousPolicy:
        motorDetails?.previousPolicyDetails?.existingPolicyClaim === YES,
      previousPolicyExpiryDate: motorDetails?.previousPolicyDetails?.expiryDate
        ? motorDetails?.previousPolicyDetails?.expiryDate
        : motorDetails?.previousPolicyDetails?.expiredDate,
      isVehicleRegisteredUnderCompanyName:
        motorDetails?.vehicleDetails?.isCompany,
      companyName: motorDetails?.vehicleDetails?.companyName,
      policyBusinessType: motorDetails?.currentPolicyDetails?.policyType,
      isPA: motorDetails?.currentPolicyDetails?.paCover,
      payAsYouDrive: false,
      insuredNoOfKms: null,
      previousNCB: motorDetails?.previousPolicyDetails.ncb,
      addOns: motorDetails?.currentPolicyDetails?.addOns,
      thirdPartyPolicyExpiryDate:
        motorDetails?.previousPolicyDetails?.thirdPartyExpiryDate || '',
      thirdPartyProvider:
        motorDetails?.previousPolicyDetails?.insuranceCompanyFirstName || '',
      thirdPartyPolicyNo:
        motorDetails?.previousPolicyDetails?.thirdPartyPolicyNo || '',
      thirdPartyStartDate:
        motorDetails?.previousPolicyDetails?.thirdPartyStartDate || '',
      vehicleSearchQuery: motorDetails?.vehicleDetails?.model?.modelGenericName,
      manufacturingMonth: motorDetails?.vehicleDetails?.monthOfManufacturer,
      manufacturingYear: motorDetails?.vehicleDetails?.yearOfManufacturer,
      engineNo: motorDetails?.vehicleDetails?.engineNumber,
      chassisNo: motorDetails?.vehicleDetails?.chassisNumber,
      city: motorDetails?.personalDetails?.city,
      state: motorDetails?.personalDetails?.state,
      pinCode: motorDetails?.personalDetails?.pincode,
      idv: motorDetails?.currentPolicyDetails?.idv,
    }
    const response = await getBikeQuickQuotes(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setLoadingQuote(false)

        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoadingQuote(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setMotorQuote(responseData?.quickQuoteResponse)
        if (!motorDetails?.previousPolicyDetails?.previousProviderLogo) {
          dispatch(
            updateMotorDetails({
              previousPolicyDetails: {
                ...motorDetails?.previousPolicyDetails,
                previousProviderLogo: responseData?.previousProviderImage,
              },
              currentPolicyDetails: {
                ...motorDetails?.currentPolicyDetails,
                idvMinValue: responseData?.minIdv,
                idvMaxValue: responseData?.maxIdv,
              },
            })
          )
        }

        if (!paCoverDetails?.paCoverValues) {
          const paAmountObject = createPaProviderObject(
            responseData?.quickQuoteResponse
          )
          dispatch(updatePACoverArray(paAmountObject))
        }
      } else {
        setMotorQuote(responseData?.quickQuoteResponse)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoadingQuote(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const fetchAddOnsList = async (token) => {
    setLoading(true)

    const response = await getAddOnsListBike(token)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setAddOnsList(responseData)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NO_ADDONS,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_ADDONS_LIST,
        })
      )
    }
  }

  useEffect(() => {
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [motorDetails])

  const handleBack = () => {
    history.push('/individual/dashboard/buyPolicy/bike')
  }

  return (
    <Box className={classes.container}>
      <LoadingModal loading={loading || loadingQuote} />

      <Grid container className={classes.sectionCover}>
        <Grid item xs={12} md={4}>
          <Box className={classes.goBack} onClick={handleBack}>
            <img src={BackArrow} alt='back-arrow-img' /> Back to Homepage{' '}
          </Box>
          <ExploreVehicleDetailsTile addOnsList={addOnsList} />
        </Grid>
        <Grid item xs={12} md={8}>
          <ExplorePolicyTypes
            quickQuote={motorQuote}
            loding={loading}
            loadingQuote={loadingQuote}
            isTwoWheeler={isTwoWheeler}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default BikeInsuranceDetails

const useStyles = makeStyles({
  sectionCover: {
    flexBasis: '30%',
    flexGrow: 1,
  },
  sectionPolicyTypes: {
    flexBasis: '100%',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    backgroundSize: '100% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
    gap: 10,
    paddingRight: 30,
    paddingLeft: 30,
    paddingTop: 20,
    paddingBottom: 20,
    '@media (max-width:750px)': {
      flexDirection: 'column',
    },
  },
  goBack: {
    paddingBottom: 10,
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '15.23px',
    color: '#3E3E3E',
    cursor: 'pointer',
  },
})
